module.exports = __webpack_public_path__ + "static/media/7.77532b95.jpg";